module.exports = __webpack_public_path__ + "media/images/competitions/book-71b2919e97fea2857331e6494e1e41c1.png";